export const docxPreviewImage = 'https://conv-sdk-cdn.spotifycdn.com/docx.png';
export const pptxPreviewImage = 'https://conv-sdk-cdn.spotifycdn.com/pptx.png';
export const xlsxPreviewImage = 'https://conv-sdk-cdn.spotifycdn.com/xlsx.png';
export const pdfPreviewImage = 'https://conv-sdk-cdn.spotifycdn.com/pdf.png';
